"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
function Message({ children, inputKind }) {
    const messageStyle = (0, react_1.useMemo)(() => (0, app_1.css) `
      ${(theme) => { var _a; return (_a = theme.inputs) === null || _a === void 0 ? void 0 : _a.message; }}
      ${(theme) => { var _a; return (_a = theme.inputs[inputKind]) === null || _a === void 0 ? void 0 : _a.message; }}
    `, [inputKind]);
    if (typeof children === 'string') {
        return ((0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ css: messageStyle, as: "caption-1" }, { children: children })));
    }
    return children;
}
exports.Message = Message;
